var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-card", {
    attrs: {
      title: "html2canvas",
      hoverable: true,
      bordered: false
    }
  }, [_c("a-button", {
    attrs: {
      slot: "extra",
      type: "primary",
      icon: "download",
      loading: _vm.loading
    },
    on: {
      click: _vm.handleScreen
    },
    slot: "extra"
  }, [_vm._v(" " + _vm._s(_vm.$t("截屏下载")) + " ")]), _c("div", {
    ref: "cutScreen",
    staticClass: "flex",
    staticStyle: {
      height: "500px"
    }
  }, [_c("div", {
    staticStyle: {
      width: "50%",
      height: "100%"
    }
  }, [_c("more-bar", {
    staticClass: "all-container"
  })], 1), _c("div", {
    staticClass: "all-container",
    staticStyle: {
      width: "50%",
      height: "100%"
    }
  }, [_c("radius-pie", {
    staticClass: "all-container"
  })], 1)])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };